<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <DatePicker type="date" v-model="start" placeholder="选择开始日期" style="width: 200px" />
            <DatePicker type="date" v-model="end" placeholder="选择结束日期" style="width: 200px" />
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%;">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
          
        <Modal v-model="showEditModal" title="编辑订单">
            <span>期数：{{ modalItem.period_number }}</span>
            <span>金额：{{ modalItem.amount }}</span>
            <span>购码：{{ formatBetContent(modalItem.bet_content) }}</span>
           <Button type="primary" @click="editOrder(1)">包赢</Button>
           <Button type="error" @click="editOrder(2)">包亏</Button>
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('del')"
            @on-ok="delRow(modalItem)"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        
    </div>
</template>
<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            start:'',
            end:'',
            totalItems: 1,
            showEditModal: false,
            columns12: [
                {
                    title: "订单号",
                    
                    key: "order_num",
                },
                {
                    title: "用户名",   
                    key: "username",
                },
                {
                    title: "产品名称",
                  
                    key: "product_name",
                },
                {
                    title: "期数",
                    
                    key: "period_number"
                },
                {
                    title: "金额",
                    
                    key: "amount",
                },
                {
                    title: this.$i18n.t('rate'),
                    
                    key: "rate"
                },
                {
                    title: "购码",
                   
                    key: "bet_content",
                    render: (h, params) => {
                        return h("span", this.formatBetContent(params.row.bet_content))
                    }
                },
                {
              title:"盈亏金额",
             
              key: "win_amount",
              render: (h, params) => {
                  if(params.row.status == 1) {
                    return h("span", {style:{color: 'green'}}, "+" + params.row.win_amount)
                  } else if(params.row.status == 2) {
                    return h("span", {style:{color: 'red'}}, "-" + params.row.lose_amount)
                  } else {
                    return h("span", {style:{color: 'black'}}, '-')
                  }
                }
            },
                {
                    title: "创建时间",
                    
                    key: "created_at",
                    render: (h, params) => {
                        return h("span", formatUTC(params.row.created_at))
                    }
                },
                {
                    title: "状态",
                    key: "status",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("Icon", {
                                props: {
                                    type: 'md-close',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'gray',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.operation(params.row)
                                    }
                                }
                            })
                        } else {
                            return h("span", {style:{color: 'green'}}, '已开奖')
                        }
                    }
                },
                {
                    title:this.$i18n.t('action'),
                    
                    key: "action",
                    render: (h, params) => {
                        if(params.row.status == 0) {
                            return h(
                                "Icon",{
                                props: {
                                    type: 'md-create',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'blue',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.editModal(params.row)
                                    }
                                }
                            })
                        }
                    }
                }
            ],
            data6: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.order, {
                page: this.currentPage,
                search: this.search,
                start: this.start,
                end: this.end
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        editModal(row) {
            this.modalItem = row;
            this.showEditModal = true;
        },
        operation(row) {
           this.$post(this.$path.change_status, {
           product_id: row.product_id,
           period_number: row.period_number,
           }).then(res => {
            if (res.errcode == 0) {
                this.$Message.success(this.$i18n.t('operateSuccess'));
                this.loadData(this.currentPage);
            }else{
                this.$Message.error(res.error || this.$i18n.t('operateFailed'));
            }
           });
          
        },
        editOrder(status) {
            let id = this.modalItem.product_id;
            let expect_item = [];
            if(status == 2) {
                expect_item = [
                    {
                        period_number: this.modalItem.period_number,
                        result: this.invert(this.modalItem.bet_content) //this.modalItem.bet_content 取反
                    }
                ]
            } else {
                expect_item = [
                    {
                        period_number: this.modalItem.period_number,
                        result: this.checkResult(this.modalItem.bet_content)
                    }
                ]

            }
            this.$post(this.$path.expect_product, {
                id: id,
                expect_item: expect_item
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(res.error || this.$i18n.t('operateFailed'));
                }
            });
            this.showEditModal = false;
            // this.loadData(this.currentPage);
          
        },
        // editMoney(row) {
        //     this.modalItem = row;
        //     this.edit_money = true;
        // },
        // edit_money_ok() {
        //     this.$post(this.$path.borrow_edit_money, {
        //         order_id: this.modalItem.order_id,
        //         money: this.modalItem.money,
        //         month:this.modalItem.month
        //     }).then(res => {
        //         if (res.success) {
        //             this.$Message.success(this.$i18n.t('operateSuccess'));
        //             this.loadData(this.currentPage);
        //         } else {
        //             this.$Message.error(this.$i18n.t('operateFailed'));
        //         }
        //     });
        // },
        invert(bet_content) {
            if(bet_content == 'big' || bet_content == 'even') {
                return 'small_odd';
            } else if(bet_content == 'small' || bet_content == 'odd') {
                return 'big_even';
            }else if(bet_content == 'big_odd') {
                return 'small_even';
            } else if(bet_content == 'small_even') {
                return 'big_odd';
            } else if(bet_content == 'big_even') {
                return 'small_odd';
            } else if(bet_content == 'small_even') {
                return 'big_odd';
            }
        },
        checkResult(bet_content) {
            switch(bet_content) {
                case 'big':
                    return 'big_odd';
                case 'small':
                    return 'small_even';
                case 'odd':
                    return 'big_odd';
                case 'even':
                    return 'small_even';
                default:
                    return bet_content;
            }
        },
        delRow(id) {
            this.$post(this.$path.order_del, {
                id: id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(row) {
            this.modalItem = row;
            this.showDelModal = true;
        },
        change_status(row) {
            this.modalItem = row;
            this.change_sts = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
       
        
        edit_status(row,status) {
            this.$post(this.$path.change_status, {
                order_id: row.id,
                status: status,
                user_id: row.user_id,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        
       formatBetContent(bet_content) {
        switch(bet_content) {
            case 'big':
                return '精品';
            case 'small':
                return '普货';
            case 'odd':
                return '单件';
            case 'even':
                return '双件';
            case 'big_odd':
                return '精品单件';
            case 'big_even':
                return '精品双件';
            case 'small_odd':
                return '普货单件';
            case 'small_even':
                return '普货双件';
            default:
                return bet_content;
        }
       },
        
        
        edit_remark(row, remark) {
            this.$post(this.$path.order_edit, {
                order_id: row.id,
                remark: remark,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/cp_order/orders.vue